import { useMemo } from 'react'

import { GroupOption } from '@/app/types'

import { type GroupsQuery, useGetGroups } from './use-get-groups'

export const useGetGroupOptions = (query: GroupsQuery = {}) => {
  const res = useGetGroups(query)

  const options = useMemo<GroupOption[]>(() => {
    const groups = res.data?.groups || []

    return groups.map((group) => ({
      numberOfContacts: group.numberOfContacts,
      label: group.name,
      recounting: group.recounting,
      value: group.id.toString(),
    }))
  }, [res.data?.groups])

  return {
    ...res,
    data: options,
  }
}
